// extracted by mini-css-extract-plugin
module.exports = {"nonScroll":"style_nonScroll__37FRS"};